export default function Hero () {
    return (<section className="hero-background">
        <div className="hero-image" />
    </section>)
}
